import React from 'react';

import { IconButton } from '@mui/material';
import { LockRounded } from '@mui/icons-material';

export const parseLockTextIntoIcon = (
  text: string,
  handleOnSampleClick: (plan: string) => void
) => {
  const LockIconComponent = (
    <IconButton size="small" sx={{ p: 0 }} onClick={() => handleOnSampleClick('expert')}>
      <LockRounded color="primary" sx={{ fontSize: 'inherit' }} />
    </IconButton>
  );
  if (text.includes('locked')) {
    const boldSplit = text.split('locked');
    const boldTextList = boldSplit.map((text, idx) => (
      <>
        {text} {idx === boldSplit.length - 1 ? <></> : LockIconComponent}
      </>
    ));
    return boldTextList;
  }
  return text;
};

// TODO: clean up this function and create fundamental parsing function for text
export const parseText = (
  text: string,
  handleOnSampleClick: (plan: string) => void,
  renderAs: 'text' | 'html' = 'html'
) => {
  if (!text) return '';

  const regex = /\*([^*]+)\*/g;
  const parts: (string | JSX.Element)[] = [];
  let lastIndex = 0;
  let match;
  let key = 0;
  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    const boldText = match[1] || match[2];
    let formattedBoldText = boldText;

    formattedBoldText =
      renderAs === 'html' ? parseLockTextIntoIcon(boldText, handleOnSampleClick) : boldText;

    if (renderAs === 'text') {
      parts.push(`<b>${formattedBoldText}</b>`);
    } else {
      parts.push(<b key={key++}>{parseLockTextIntoIcon(boldText, handleOnSampleClick)}</b>);
    }
    lastIndex = regex.lastIndex;
  }
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }
  return renderAs === 'text' ? parts.join('') : parts;
};

export const wrapLabel = (text: string, maxChars = 12): string[] => {
  const words = text.split(' ');
  const lines: string[] = [];
  let currentLine = '';

  words.forEach(word => {
    if (word.length > maxChars) {
      // flush the current line if it has content
      if (currentLine) {
        lines.push(currentLine.trim());
        currentLine = '';
      }
      // break long word into chunks
      const chunks = word.match(new RegExp(`.{1,${maxChars}}`, 'g')) || [];
      lines.push(...chunks);
    } else {
      // check if we can add this word to the current line
      if ((currentLine + ' ' + word).trim().length <= maxChars) {
        currentLine += (currentLine ? ' ' : '') + word;
      } else {
        lines.push(currentLine.trim());
        currentLine = word;
      }
    }
  });

  if (currentLine) {
    lines.push(currentLine.trim());
  }

  return lines;
};

export const convertSnakeCaseToTitleCase = (text: string) => {
  return (
    text
      .replace('_', ' ')
      .charAt(0)
      .toUpperCase() + text.replace('_', ' ').slice(1)
  );
};
